/**
 * Decodes HTML entities in gift product names. A detached `textarea` is safe here — its `innerHTML`
 * cannot execute scripts or build elements the way a live element's would.
 */
export function decodeEntities(value: string): string {
  if (!value) return ''
  if (typeof document === 'undefined') return value

  const element = document.createElement('textarea')
  element.innerHTML = value

  return element.value
}
